// extracted by mini-css-extract-plugin
export default {"block":"VmIH81oF"};